import Footer from '@/components/Footer';
import ScrollLockFix from '@/components/client/ScrollLockFix';
import { webTheme } from '@/theme/theme';
import { ThemeProvider } from '@mui/material/styles';
import type { AppProps } from 'next/app';
import '../app/[locale]/globals.css';
import { NextIntlClientProvider } from 'next-intl';

export default function App({ Component, pageProps }: AppProps) {
  return (
    <NextIntlClientProvider locale={pageProps.locale || 'en'} messages={pageProps.messages || {}}>
      <ThemeProvider theme={webTheme}>
        <ScrollLockFix />
        <Component {...pageProps} />
        <Footer {...pageProps} />
      </ThemeProvider>
    </NextIntlClientProvider>
  );
}
